import React, { createRef, useEffect } from 'react';
import scrollToComponent from 'react-scroll-to-component';
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';
import AOS from 'aos';
import '../App.scss';
import Earn from '../components/Earn';
import Advertise from '../components/Advertise';
import Reward from '../components/Reward';
import Tribe from '../components/Tribe';
import How from '../components/How';
import Env from '../components/Env';
import Social from '../components/Social';
import Nav from '../components/Nav';
import Video from '../components/Video';
import Footer from '../components/Footer';
import { LINKS } from '../constants/LINKS';

function AppView() {
  let tribe = createRef();
  let contact = createRef();
  useEffect(() => {
    AOS.refreshHard();
  });
  const onLinkClick = (event) => {
    let ref;
    let alignment = 'middle';
    let offset = 0;
    switch (event) {
      case LINKS.ABOUT:
        ReactGA.pageview('/about-us');
        ReactPixel.trackCustom('/about-us');
        ref = tribe;
        alignment = 'top';
        offset = -200;
        break;
      case LINKS.JOIN:
        ReactGA.pageview('/join-us');
        ReactPixel.trackCustom('/join-us');
        ref = tribe;
        alignment = 'bottom';
        offset = 200;
        break;
      case LINKS.CONTACT:
        ReactGA.pageview('/contact-us');
        ReactPixel.trackCustom('/contact-us');
        ref = contact;
        alignment = 'bottom';
        offset = 0;
        break;
      default:
        ref = tribe;
    }
    scrollToComponent(ref, { align: alignment, offset: offset });
  };

  return (
    <div>
      <div>
        <div className="NavCont">
          <Nav onLinkClick={(event) => onLinkClick(event)} />
        </div>
        <Video />
        <div>
          {/*EARN COMPONENT*/}
          <div data-aos="fade-up" data-aos-anchor-placement="top-center">
            <Earn />
          </div>
          {/*ADVERTISE COMPONENT*/}
          <div data-aos="fade-up" data-aos-anchor-placement="top-center">
            <Advertise />
          </div>
          {/*REWARD COMPONENT*/}
          <div data-aos="fade-up" data-aos-anchor-placement="top-center">
            <Reward />
          </div>
          {/*TRIBE COMPONENT */}
          <div
            ref={(section) => {
              tribe = section;
            }}
          >
            <Tribe />
          </div>
          {/*HOW COMPONENT*/}
          <div data-aos="fade-up" data-aos-anchor-placement="top-center">
            <How />
          </div>
          {/*ENV COMPONENT*/}
          <div data-aos="fade-up" data-aos-anchor-placement="top-center">
            <Env />
          </div>
          {/*SOCIAL COMPONENT*/}
          <div data-aos="fade-up" data-aos-anchor-placement="top-center">
            <Social />
          </div>
          <div
            ref={(section) => {
              contact = section;
            }}
          >
            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AppView;
